var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { nanoid } from 'nanoid';
import React, { useEffect, useState } from 'react';
import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect';
var serverHandoffComplete = false;
function generateId() {
    return nanoid(6);
}
function useGeneratedId() {
    // If this instance isn't part of the initial render it doesn't have to double render
    // Just generate the ID and return it
    var initialId = serverHandoffComplete ? generateId() : null;
    var _a = __read(useState(initialId), 2), id = _a[0], setId = _a[1];
    useIsomorphicLayoutEffect(function () {
        // Patch the ID after render
        // To avoid possible flickering useLayoutEffect is used
        if (id == null) {
            setId(generateId());
        }
    }, []);
    useEffect(function () {
        // Flag all future uses of useId to skip unnecessary re-renders
        if (!serverHandoffComplete) {
            serverHandoffComplete = true;
        }
    }, []);
    return id;
}
// toString prevents bundlers from importing it
// @ts-expect-error: might not exist
var useReactId = React['useId'.toString()];
/**
 * Autogenerate random ID to facilitate accessibility features.
 *
 * When available use React 18 built-in `useId`, otherwise fall back to a bit less performant implementation.
 *
 * @returns Random ID
 */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
var useId = useReactId !== null && useReactId !== void 0 ? useReactId : useGeneratedId;
export default useId;
